import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import styles from "./PremiumBlurOverlay.module.css";

interface PremiumBlurOverlayProps {
  children: ReactNode;
  description: string;
}

export function PremiumBlurOverlay({ children, description }: PremiumBlurOverlayProps) {
  return (
    <div className={styles.wrapper}>
      {/* @ts-expect-error inert é um atributo HTML válido, o React ainda não tipa 100% */}
      <div className={styles.blurred} aria-hidden inert="">
        {children}
      </div>
      <div className={styles.overlay}>
        <div className={styles.card}>
          <div className={styles.badge}>
            <Crown size={20} strokeWidth={2} />
          </div>
          <p className={styles.description}>{description}</p>
          <Link to="/premium" className={styles.cta}>
            Ver planos Premium
          </Link>
        </div>
      </div>
    </div>
  );
}
